import React from 'react';
import { Link, useNavigate } from 'react-router-dom';
import { useAuth } from '../context/AuthContext';
import './Header.css';

const Header = () => {
  const { user, isAuthenticated, logout, isPremium, isAdmin } = useAuth();
  const navigate = useNavigate();

  const handleLogout = () => {
    logout();
    navigate('/');
  };

  return (
    <header className="header">
      <div className="container">
        <div className="header-content">
          <Link to="/" className="logo">
            <span className="logo-icon">📝</span>
            <span className="logo-text">PrivateSold</span>
          </Link>

          <nav className="nav">
            <Link to="/bill-of-sale" className="nav-link">
              Bill of Sale
            </Link>
            <Link to="/invoice" className="nav-link">
              Invoice
            </Link>
            <Link to="/blog" className="nav-link">
              Blog
            </Link>
            {isAuthenticated && (
              <Link to="/dashboard" className="nav-link">
                Dashboard
              </Link>
            )}
            {isAdmin() && (
              <Link to="/admin" className="nav-link nav-link-admin">
                Admin
              </Link>
            )}
          </nav>

          <div className="header-actions">
            {isAuthenticated ? (
              <>
                {!isPremium() && (
                  <Link to="/subscription" className="btn btn-success btn-sm">
                    Upgrade
                  </Link>
                )}
                <div className="user-menu">
                  <button className="user-button">
                    <span className="user-avatar">
                      {user?.firstName?.[0]}{user?.lastName?.[0]}
                    </span>
                    <span className="user-name">{user?.firstName}</span>
                  </button>
                  <div className="user-dropdown">
                    <Link to="/profile" className="dropdown-item">
                      Profile
                    </Link>
                    <Link to="/subscription" className="dropdown-item">
                      Subscription
                    </Link>
                    <div className="dropdown-divider"></div>
                    <button onClick={handleLogout} className="dropdown-item">
                      Logout
                    </button>
                  </div>
                </div>
              </>
            ) : (
              <>
                <Link to="/login" className="btn btn-secondary btn-sm">
                  Login
                </Link>
                <Link to="/register" className="btn btn-primary btn-sm">
                  Sign Up
                </Link>
              </>
            )}
          </div>
        </div>
      </div>
    </header>
  );
};

export default Header;
